import { z } from 'zod'

/** Job periódico que observa a sessão do WhatsApp sem enviar mensagens. */
export const FILA_MONITOR_WAHA = 'dv-monitor-waha'

/**
 * O WAHA acrescenta campos entre versões; nome, estado e formatos conhecidos de
 * metadados continuam validados. `status` é conjunto aberto de propósito: estado
 * novo precisa degradar a saúde, não derrubar o parser e esconder a indisponibilidade.
 */
export const sessaoWaha = z
  .object({
    name: z.string().trim().min(1),
    status: z.string().trim().min(1),
    engine: z.union([
      z.object({ engine: z.string().trim().min(1) }),
      z.object({
        grpc: z.object({
          client: z.string().trim().min(1),
          stream: z.string().trim().min(1),
        }),
        // GOWS 2026.8.1 omite este bloco enquanto o cliente gRPC não existe.
        gows: z.object({ found: z.boolean(), connected: z.boolean() }).optional(),
      }),
    ]).optional(),
  })
  .loose()

export type SessaoWaha = z.infer<typeof sessaoWaha>
